import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

interface LocalSEOLocationsGridProps {
  language: 'es' | 'en';
}

export const LocalSEOLocationsGrid = ({ language }: LocalSEOLocationsGridProps) => {
  const content = {
    es: {
      title: "Ubicaciones atendidas",
      subtitle: "Servicios de SEO local disponibles en las siguientes áreas.",
      viewAll: "Ver servicios"
    },
    en: {
      title: "Locations served",
      subtitle: "Local SEO services available in the following areas.",
      viewAll: "View services"
    }
  };

  const locations = [
    {
      name: "Houston",
      slug: language === 'es' ? "/seo-local-houston" : "/local-seo-houston",
      region: "Texas",
      primary: true
    },
    {
      name: "The Woodlands",
      slug: "/seo-the-woodlands",
      region: "Texas",
      primary: false
    },
    {
      name: "Spring",
      slug: "/seo-spring",
      region: "Texas",
      primary: false
    },
    {
      name: "Katy",
      slug: "/seo-katy",
      region: "Texas",
      primary: false
    },
    {
      name: "Conroe",
      slug: "/seo-conroe",
      region: "Texas",
      primary: false
    },
    {
      name: "Sugar Land",
      slug: "/seo-sugar-land",
      region: "Texas",
      primary: false
    },
    {
      name: "Orlando",
      slug: "/seo-orlando",
      region: "Florida",
      primary: false
    },
    {
      name: "Miami",
      slug: "/seo-miami",
      region: "Florida",
      primary: false
    }
  ];

  const t = content[language];

  return (
    <section className="section-padding bg-secondary/30">
      <div className="container-custom">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            {t.title}
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            {t.subtitle}
          </p>
        </div>
        
        <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 max-w-5xl mx-auto">
          {locations.map((location, index) => (
            <Link 
              key={index}
              to={location.slug}
              className={`
                group flex items-center gap-3 p-4 rounded-xl border transition-all
                ${location.primary 
                  ? 'bg-brand text-white border-brand hover:bg-brand/90' 
                  : 'bg-background border-border hover:border-brand hover:shadow-md'
                }
              `}
            >
              <MapPin className={`w-5 h-5 flex-shrink-0 ${location.primary ? 'text-white' : 'text-brand'}`} />
              <div className="flex-1">
                <span className={`font-semibold ${location.primary ? 'text-white' : 'text-foreground'}`}>
                  {location.name}
                </span>
                <span className={`text-sm block ${location.primary ? 'text-white/80' : 'text-muted-foreground'}`}>
                  {location.region}
                </span>
              </div>
              <ArrowRight className={`w-4 h-4 group-hover:translate-x-1 transition-transform ${location.primary ? 'text-white' : 'text-muted-foreground'}`} />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
